module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO01.78ce91d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO01.mp4
// module id = 729
// module chunks = 1